function _(r,t,n){var o=r(33);t.exports=function(r){if(!o(r))return!1;try{return!!r.constructor&&r.constructor.prototype===r}catch(r){return!1}}}
//# sourceMappingURL=is.min.js.map